var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.8652 20.6927L16.3215 15.15C16.2227 15.0512 16.0938 14.9997 15.9562 14.9997H15.5136C16.9876 13.4056 17.8901 11.2787 17.8901 8.93706C17.8901 4.0002 13.8892 0 8.9514 0C4.01362 0 0.0126953 4.0002 0.0126953 8.93706C0.0126953 13.8739 4.01362 17.8741 8.9514 17.8741C11.2935 17.8741 13.4207 16.9718 15.0151 15.5024V15.9406C15.0151 16.0781 15.071 16.207 15.1655 16.3058L20.7092 21.8485C20.9112 22.0505 21.2378 22.0505 21.4398 21.8485L21.8652 21.4232C22.0672 21.2212 22.0672 20.8947 21.8652 20.6927ZM8.9514 16.4992C4.76997 16.4992 1.38788 13.1177 1.38788 8.93706C1.38788 4.75641 4.76997 1.37493 8.9514 1.37493C13.1328 1.37493 16.5149 4.75641 16.5149 8.93706C16.5149 13.1177 13.1328 16.4992 8.9514 16.4992Z","fill":"white"}));
}

SearchInline.defaultProps = {"width":"23","height":"22","viewBox":"0 0 23 22","fill":"none"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
